import React, { memo } from "react"
import styled from "styled-components"
import Link from "next/link"
import { useConfig } from "~/composable/useConfig"
import TaskTag from "~/components/molecules/TaskTag"

interface Props {
  title?: string
  dataSources: { [KEY in string]: string | number }[]
  limit?: number
}

function TaskView(props: Props) {
  const { title, dataSources, limit } = props
  const config = useConfig()
  const newStatusContract = 21
  return (
    <Content>
      <LinkArea>
        <div className={"title"}>{title}</div>
      </LinkArea>
      {dataSources && (
        <Table>
          {dataSources.map((dataSource, dataSourceIndex) => (
            <React.Fragment key={dataSourceIndex}>
              {dataSource.status !== newStatusContract && (
                <div className={"table-row"}>
                  <div className={"message"}>
                    <Link
                      href={{
                        pathname: `/contracts${dataSource.version === 2 ? "-next" : ""}/${
                          dataSource.id
                        }`,
                      }}
                    >
                      {dataSource.name}
                    </Link>
                    {dataSource.message}
                  </div>
                  <TaskTag status={dataSource.status as number} />
                </div>
              )}
            </React.Fragment>
          ))}
        </Table>
      )}
    </Content>
  )
}

const Content = styled.div`
  background-color: #ffffff;
  width: 48%;
  border: 1px solid #d3d3d3;
`

const LinkArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;

  .title {
    font-size: 16px;
    font-weight: bold;
  }
`

const Table = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  max-height: 430px;
  border-top: 1px solid #d3d3d3;
  overflow: scroll;

  > div {
    display: flex;
    text-align: center;
  }

  .table-row {
    display: flex;
    align-items: center;
    min-height: 72px;
    padding: 0 20px;
    justify-content: space-between;
    border-bottom: 1px dashed #d3d3d3;

    .message > a {
      text-align: left;
      color: #4f4ce6;
    }
  }
`
export default memo(TaskView)
